import { gql } from '@apollo/client';

export const CREATE_USER = gql(/* GraphQL */ `
    mutation CreateUser($input: CreateUserInput!) {
        createUser(createUserInput: $input) {
            id
            firstName
            lastName
            email
            isActive
            userRole {
                role
            }
            managerStore {
                id
                name
            }
        }
    }
`);

export const UPDATE_USER = gql(/* GraphQL */ `
    mutation UpdateUser($input: UpdateUserInput!) {
        updateUser(updateUserInput: $input) {
            id
            firstName
            lastName
            email
            isActive
            userRole {
                role
            }
            managerStore {
                id
                name
            }
        }
    }
`);

export const MOVE_STORE_MANAGER = gql(/* GraphQL */ `
    mutation MoveStoreManager($userId: String!, $storeId: String!) {
        moveStoreManager(userId: $userId, storeId: $storeId) {
            id
            firstName
            lastName
            email
            isActive
            userRole {
                role
            }
            managerStore {
                id
                name
            }
        }
    }
`);

export const DELETE_USER = gql(/* GraphQL */ `
    mutation DeleteUser($id: String!) {
        deleteUser(id: $id) {
            id
            firstName
            lastName
        }
    }
`);
